// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"784":"a35f9cf8","854":"c85bddfb","935":"4d95596e"}[chunkId] + ".js";
};